import ReservationWeekType from "./ReservationWeekType";

export default class ReservationWeekTypeClass {
  constructor(private readonly _value: ReservationWeekType = ReservationWeekType.NONE) {
  }

  get value() {
    return this._value;
  }
}